import { render, staticRenderFns } from "./ApplyPoint.vue?vue&type=template&id=4a5996a8&scoped=true&"
import script from "./ApplyPoint.vue?vue&type=script&lang=ts&"
export * from "./ApplyPoint.vue?vue&type=script&lang=ts&"
import style0 from "./ApplyPoint.vue?vue&type=style&index=0&id=4a5996a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5996a8",
  null
  
)

export default component.exports